import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPagedUserResultRequestDto } from 'src/app/models/backend';
import { IUserDto } from 'src/app/models/backend/users';
import { PagedListingComponentBase, PagedRequestDto } from 'src/app/shared/reusable/paged-listing-component-base';
import { CreateUsersComponent } from './create-users/create-users.component';
import { UsersService } from './users.service';
import Swal from 'sweetalert2';
import { UpdateUsersComponent } from './update-users/update-users.component';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends PagedListingComponentBase<IUserDto>{
  loader=false;
  Users:any

  request: IPagedUserResultRequestDto = {
    isInvoledDeletedItems: false,
    Keyword:"",
    maxResultCount:10,
    skipCount:0
  };
  Role:any
  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    public userService:UsersService,public loginService:LoginService
  ){
    super();
    this.Role=localStorage.getItem("RoleType")
  }
 
  protected override list(request: PagedRequestDto, pageNumber: number,): void {
    this.loader=true
    this.userService.GetUsers(request).subscribe((res: any) => {
      this.Users = res.items;
      console.log(this.Users)
      this.showPaging(res, pageNumber)
      this.loader=false
    })
  }
  protected override delete(entity: IUserDto): void {
    throw new Error('Method not implemented.');
  }
  openCreateModal() {
    const modalRef = this.modalService.open(CreateUsersComponent, {
      size: 'md', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  isRefresh(refresh: boolean) { if (refresh === true) this.getDataPage(1); }

  onPageChanged(pageNumber: number) {
    this.request = {
      isInvoledDeletedItems: false,
      skipCount: (pageNumber - 1) * 10,
      maxResultCount: 10,

    }
    console.log(this.request)
    this.list(this.request, pageNumber,)
    this.getDataPage(pageNumber);
  }

  onChangeFilter() {
    // this.getDataPage(1);
  }
  Delete(Id) {
    Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Deleted!',
          'Location has been deleted.',
          'success'
        )
        this.userService.DeleteUser(Id).subscribe((res: any) => {
          this.getDataPage(1)
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Location is not deleted',
          'error'
        )
      }
    })
  }

  Edit(id) {
    this.userService.id = id
    const modalRef = this.modalService.open(UpdateUsersComponent, {
      size: 'md', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  Filter(keyword) {
    this.request = {
      Keyword: keyword,
      isInvoledDeletedItems: false,
      skipCount: 0,
      maxResultCount: 10
    }
    this.userService.GetUsers(this.request).subscribe((res: any) => {
      this.Users = res.items;
      this.showPaging(res, 1)

    })
  }
  // logout() {
  //   this.loginService.logout();
  // }
}
